import { type UseQueryResult, useQuery } from 'react-query';
import { TransactionService } from '../../services/wealthlane-award-services';

const useGetTransactionTransferAllocateStatus = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const transactionTransferAllocateStatus = useQuery(
    ['getTransactionTransferAllocateStatus'],
    async () => {
      return await handleRequest(
        TransactionService.getApiAwardApiAppTransactionTransferAllocateStatusList()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.displayName ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return transactionTransferAllocateStatus;
};

export default useGetTransactionTransferAllocateStatus;
